import { recordMark } from '@stitch-fix/client-analytics-reporter';
import { sendLog } from '../../utils/sendMetrics';
import { useGetShopRecommendedSizeQuery } from './getShopRecommendedSize';
import mockedResponse from './useShopProductSizeOptionsQuery.mockedResponse';

const useShopRecommendedSizeQuery = ({
  skuId,
  skip,
}: {
  skuId: string;
  skip: boolean;
}) => {
  const {
    data: shopRecommendedSizeData,
    loading: shopRecommendedSizeLoading,
    error: shopRecommendedSizeError,
  } = useGetShopRecommendedSizeQuery({
    skip,
    variables: {
      skuId,
    },
    onCompleted: () => {
      recordMark('get_shop_recommended_size_query_completed', {
        graph_query_succeeded: true,
      });
    },
    onError: () => {
      recordMark('get_shop_recommended_size_query_completed', {
        graph_query_succeeded: false,
      });
      sendLog(
        `GetShopRecommendedSize error for sku ID ${skuId}: ${shopRecommendedSizeError}`,
        {
          skuId,
          error_message: shopRecommendedSizeError,
        },
      );
    },
  });

  /* @ts-ignore no type for window */
  if (window.gon.use_mock_graphql_data) {
    return {
      shopRecommendedSizeData: mockedResponse.data,
      shopRecommendedSizeLoading,
      shopRecommendedSizeError,
    };
  }

  return {
    shopRecommendedSizeData,
    shopRecommendedSizeLoading,
    shopRecommendedSizeError,
  };
};

export default useShopRecommendedSizeQuery;
